import {csRobotInfo$, type CsRobotInfo} from '@px/streams/cs-robot';
import {adaUtil} from './ada';
import {zeUtil} from './zendesk';

export const csRobotUtil = {
  init(csRobotInfo: CsRobotInfo, lang: Language = 'en', onload) {
    const util = getUtil(csRobotInfo);
    util && util.init(lang, onload, csRobotInfo);
  },
  changeUserInfo(userInfo, userTags, userMemberLevel) {
    const csRobotInfo = csRobotInfo$.getValue();
    const util = getUtil(csRobotInfo);
    util && util.changeUserInfo(userInfo, convertTags(userTags, userMemberLevel));
  },
  async openChat() {
    const csRobotInfo = csRobotInfo$.getValue();
    const util = getUtil(csRobotInfo);
    util && util.openChat();
  },
  async hideChat() {
    const csRobotInfo = csRobotInfo$.getValue();
    const util = getUtil(csRobotInfo);
    util && util.hideChat();
  },
};

function getUtil(csRobotInfo: CsRobotInfo) {
  if (!csRobotInfo) {
    return;
  }
  if (csRobotInfo.name === 'AdaZAW') {
    return adaUtil;
  }
  if (csRobotInfo.name === 'PhemexBot') {
    return zeUtil;
  }
  return null;
}

function convertTags(tagsInfo, userMemberLevel) {
  const vipTag = 'VIP: ' + userMemberLevel;
  if (!tagsInfo) {
    return [vipTag];
  }
  const tagKey = ['uid', 'kycCountry', 'ptStake', 'apiUser', 'bonusHunter', 'referralId', 'kol', 'registerDate', 'hasRecentTrade', 'ka'];
  const tags = Object.keys(tagsInfo)
    .map((key) => {
      if (tagKey.includes(key) && tagsInfo[key]) {
        if (typeof tagsInfo[key] === 'boolean') {
          return key;
        }
        return `${key}: ${tagsInfo[key]}`;
      }
      return '';
    })
    .filter(Boolean);
  return [vipTag, ...tags];
}
